import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseInputComponent } from '../base-input/base-input.component';

export interface IMaskConfig {
  mask: string;
  validation?: boolean;
  specialCharacters?: string[];
  showMaskTyped?: boolean;
}

@Component({
  selector: 'input-mask-base',
  templateUrl: './base-input-mask.component.html',
  providers: [ {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => BaseInputMaskComponent),
    multi: true
  } ]
})
export class BaseInputMaskComponent extends BaseInputComponent implements OnInit {

  @Input() mask: IMaskConfig = <IMaskConfig>{ mask: '', validation: false, specialCharacters: [], showMaskTyped: false };

}
